import { render } from "./UserListTableCell.vue?vue&type=template&id=bb2bbe3c&scoped=true&ts=true"
import script from "./UserListTableCell.vue?vue&type=script&lang=ts"
export * from "./UserListTableCell.vue?vue&type=script&lang=ts"

import "./UserListTableCell.vue?vue&type=style&index=0&id=bb2bbe3c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2bbe3c"]])

export default __exports__